import { UserDataResponseDto } from '@/domain/common';
import { UserDataResponse } from '@/domain/user';

export const enhanceUserData = async <T extends UserDataResponseDto | UserDataResponse>(userData: T) => {
    userData.fullName = `${userData?.firstName} ${userData?.lastName}`;

    return userData;
};
